import PropTypes from "prop-types";
import { URL_KEYS } from "constants/dashboard";
import { SORT_DIRECTION } from "constants/common";
import SortButton from "components/common/SortButton";
import useEvent from "hooks/useEvent";
import useRouterSearchParams from "hooks/useRouterSearchParams";

export default function SortHeaderWithSearchParams({ name, className, children }) {
  const [searchParams, setSearchParams] = useRouterSearchParams();
  const sortByValue = searchParams.get(URL_KEYS.sortBy);
  const sortDirValue = searchParams.get(URL_KEYS.sortDir);
  const isSorted = sortByValue === name;

  const setSortBy = useEvent(() => {
    const curSearchParams = new URLSearchParams(searchParams);
    if (sortByValue !== name) {
      curSearchParams.set(URL_KEYS.sortBy, name);
      curSearchParams.set(URL_KEYS.sortDir, SORT_DIRECTION[0]);
      setSearchParams(curSearchParams);
      return;
    }

    const index = SORT_DIRECTION.findIndex((v) => v === sortDirValue);
    const value = SORT_DIRECTION[index + 1];

    if (value === undefined) {
      curSearchParams.delete(URL_KEYS.sortBy);
      curSearchParams.delete(URL_KEYS.sortDir);
    } else {
      curSearchParams.set(URL_KEYS.sortBy, name);
      curSearchParams.set(URL_KEYS.sortDir, value);
    }

    setSearchParams(curSearchParams);
  });

  return (
    <SortButton
      className={className}
      onClick={setSortBy}
      isSorted={isSorted}
      sortDir={sortDirValue}
    >
      {children}
    </SortButton>
  );
}

SortHeaderWithSearchParams.propTypes = {
  name: PropTypes.string.isRequired,
  className: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.arrayOf(PropTypes.node)]),
};
